<template>
  <div class="binding-otp">
    <div class="title">
      {{ $t('i18n_binding_otp') }}
    </div>
    <div class="binding-otp__content">
      <div class="binding-otp__step-one">
        <p>{{ $t('i18n_otp_msg_step1') }}</p>
        <a-button type="primary" @click="_handleNavigateToGoogleAuthenticator">
          {{ $t('i18n_install_google_authenticator') }}
        </a-button>
        <a-button type="primary" @click="_handleDownloadApk">
          {{ $t('i18n_download_authenticator_apk') }}
        </a-button>
      </div>
      <div class="binding-otp__step-two">
        <p>
          {{ $t('i18n_otp_msg_step2') }}
        </p>
        <div ref="qrCodeDiv" class="binding-otp__qrcode" />
        <a-button type="primary" @click="_handleNavigateToVerifyOtp">
          {{ $t('i18n_go_to_verify_otp') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'OtpBinding',
  mounted() {
    this.bindQRCode()
  },
  methods: {
    bindQRCode: function() {
      new QRCode(this.$refs.qrCodeDiv, {
        text: this.$route.params.otpURL,
        width: 200,
        height: 200,
        correctLevel: QRCode.CorrectLevel.L
      })
    },
    _handleNavigateToGoogleAuthenticator() {
      window.open(
        'https://support.google.com/accounts/answer/1066447?co=GENIE.Platform%3DAndroid&hl=zh-Hans&oco=0'
      )
    },
    _handleDownloadApk() {
      window.open('https://lihi1.cc/QHI0g')
    },
    _handleNavigateToVerifyOtp() {
      const params = this.$route.params
      this.$router.push({ name: 'OtpVerify', params })
    }
  }
}
</script>
